import { Box, Flex, Heading } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useDocumentsViewModel } from '../../models/DocumentsViewModel';
import { Agreement } from '../../../types';

type AgreementItemProps = {
  agreement: Agreement;
};

const AgreementItem: React.FC<AgreementItemProps> = ({ agreement }) => {
  return (
    <Flex
      mb="20px"
      as={Link}
      to={agreement.link}
      target={agreement.accepted ? '_blank' : '_self'}
      alignItems={'center'}
      justifyContent={'space-between'}
      cursor="pointer"
      borderColor="black"
      borderRadius="10px"
      borderStyle={'solid'}
      borderWidth="1px"
      padding="20px"
      shadow="0px 4px 6px -1px #00000011"
      w="full">
      <TextBlock weight="bold">{agreement.title}</TextBlock>
      {agreement.accepted ? (
        <Icon variant="regular" color="green" icon="circle-check" />
      ) : (
        <Icon variant="regular" color="red" icon="times" />
      )}
    </Flex>
  );
};

export const Agreements: React.FC = () => {
  const documentsViewModel = useDocumentsViewModel();

  return (
    <Box w="100%" p="24px">
      <Heading lineHeight={1} fontWeight="normal" fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
        Agreements
      </Heading>
      <TextBlock fontSize="14px" mt="8px" mb="24px">
        {`${documentsViewModel.signedAgreements}/5 Agreements Signed`}
      </TextBlock>
      <Box display="grid" gridTemplateColumns={['100%', '100%', '50% 50%']} gap="10px" flexWrap={'wrap'} w="full">
        {documentsViewModel.agreements.map((agreement, i) => (
          <Box key={`agreement-${i}`} w={['full']}>
            <AgreementItem agreement={agreement} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
